import { HttpErrorResponse } from '@angular/common/http';
import { Certificate } from 'app/library/certificate/models/certificate.model';
import { FinalGradeCertificate } from 'app/library/certificate/services/certificate.api-service';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { IManageModuleUserCertificatesActionPayload } from '../interfaces/module-certificate-action.action-payload.interface';
import { ModuleCertificateExtended } from '../models/module-certificate.extended.model';
import { ModuleCertificate } from '../models/module-certificate.model';
import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';

interface CreateModuleCertificateActionPayload {
    moduleId: string;
    assignmentRule: number;
}

export interface CreatePrivateModuleCertificateActionPayload extends CreateModuleCertificateActionPayload {
    file: File;
}

export interface CreatePublicModuleCertificateActionPayload extends CreateModuleCertificateActionPayload {
    certificate: Certificate;
}

export class SetModuleCertificate {
    static readonly type = '[ModuleCertificate] SetModuleCertificate';

    constructor(public payload: ModuleCertificate) {}
}

export class SetModuleCertificates {
    static readonly type = '[ModuleCertificate] SetModuleCertificates';

    constructor(public payload: ModuleCertificate[]) {}
}

export class CreatePrivateModuleCertificate {
    static readonly type = '[ModuleCertificate] CreatePrivateModuleCertificate';

    constructor(public payload: CreatePrivateModuleCertificateActionPayload) {}
}

export class CreatePrivateModuleCertificateSuccess {
    static readonly type = '[ModuleCertificate] CreatePrivateModuleCertificateSuccess';

    constructor(public payload: ModuleCertificateExtended) {}
}

export class CreatePrivateModuleCertificateFailure {
    static readonly type = '[ModuleCertificate] CreatePrivateModuleCertificateFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class CreatePublicModuleCertificate {
    static readonly type = '[ModuleCertificate] CreatePublicModuleCertificate';

    constructor(public payload: CreatePublicModuleCertificateActionPayload) {}
}

export class CreatePublicModuleCertificateSuccess {
    static readonly type = '[ModuleCertificate] CreatePublicModuleCertificateSuccess';

    constructor(public payload: ModuleCertificateExtended) {}
}

export class CreatePublicModuleCertificateFailure {
    static readonly type = '[ModuleCertificate] CreatePublicModuleCertificateFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class UnsetModuleCertificate {
    static readonly type = '[ModuleCertificate] UnsetModuleCertificate';
}

export class FetchModuleCertificate {
    static readonly type = '[ModuleCertificate] FetchModuleCertificate';

    constructor(public payload: string) {}
}

export class FetchModuleCertificateSuccess {
    static readonly type = '[ModuleCertificate] FetchModuleCertificateSuccess';

    constructor(public payload: ModuleCertificateExtended) {}
}

export class FetchModuleCertificateFailure {
    static readonly type = '[ModuleCertificate] FetchModuleCertificateFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class UpdateModuleCertificate {
    static readonly type = '[ModuleCertificate] UpdateModuleCertificate';

    constructor(public payload: ModuleCertificateExtended) {}
}

export class UpdateModuleCertificateSuccess {
    static readonly type = '[ModuleCertificate] UpdateModuleCertificateSuccess';

    constructor(public payload: ModuleCertificateExtended) {}
}

export class UpdateModuleCertificateFailure {
    static readonly type = '[ModuleCertificate] UpdateModuleCertificateFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteModuleCertificateTemplate {
    static readonly type = '[ModuleCertificate] DeleteModuleCertificateTemplate';

    constructor(public payload: { certificateId: string; moduleId: string }) {}
}

export class DeleteModuleCertificateTemplateSuccess {
    static readonly type = '[ModuleCertificate] DeleteModuleCertificateTemplateSuccess';

    constructor() {}
}

export class DeleteModuleCertificateTemplateFailure {
    static readonly type = '[ModuleCertificate] DeleteModuleCertificateTemplateFailure';

    constructor(public payload: string) {}
}

export class DeleteModuleCertificate {
    static readonly type = '[ModuleCertificate] DeleteModuleCertificate';

    constructor(public payload: string) {}
}

export class DeleteModuleCertificateSuccess {
    static readonly type = '[ModuleCertificate] DeleteModuleCertificateSuccess';

    constructor() {}
}

export class DeleteModuleCertificateFailure {
    static readonly type = '[ModuleCertificate] DeleteModuleCertificateFailure';

    constructor(public payload: string) {}
}

export class UpdateModuleCertificateTemplate {
    static readonly type = '[ModuleCertificate] UpdateModuleCertificateTemplate';

    constructor(public payload: { id: string; certificateName: string; moduleId?: string }) {}
}

export class UpdateModuleCertificateTemplateSuccess {
    static readonly type = '[ModuleCertificate] UpdateModuleCertificateTemplateSuccess';

    constructor(public payload: Certificate) {}
}

export class UpdateModuleCertificateTemplateFailure {
    static readonly type = '[ModuleCertificate] UpdateModuleCertificateTemplateFailure';

    constructor() {}
}

export class UnassignCertificatesFromModuleUsers {
    static readonly type = '[ModuleCertificate] UnassignCertificatesFromModuleUsers';

    constructor(public payload: IManageModuleUserCertificatesActionPayload) {}
}

export class UnassignCertificatesFromModuleUsersSuccess {
    static readonly type = '[ModuleCertificate] UnassignCertificatesFromModuleUsersSuccess';

    constructor(public payload: { removed: number }) {}
}

export class UnassignCertificatesFromModuleUsersFailure {
    static readonly type = '[ModuleCertificate] UnassignCertificatesFromModuleUsersFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class AssignCertificatesToModuleUsers {
    static readonly type = '[ModuleCertificate] AddUsersToAudience';

    constructor(public payload: IManageModuleUserCertificatesActionPayload) {}
}

export class AssignCertificatesToModuleUsersSuccess {
    static readonly type = '[ModuleCertificate] AssignCertificatesToModuleUsersSuccess';

    constructor(public payload: { existing: FinalGradeCertificate[]; newlyAssigned: FinalGradeCertificate[] }) {}
}

export class AssignCertificatesToModuleUsersFailure {
    static readonly type = '[ModuleCertificate] AssignCertificatesToModuleUsersFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class FetchModuleUsedTemplates {
    static readonly type = '[ModuleCertificate] FetchModuleUsedTemplates';

    constructor(
        public payload?: {
            moduleId: string;
        }
    ) {}
}

export class FetchModuleUsedTemplatesSuccess {
    static readonly type = '[ModuleCertificate] FetchModuleUsedTemplatesSuccess';

    constructor(public payload: SimpleCertificate[]) {}
}

export class FetchModuleUsedTemplatesFailure {
    static readonly type = '[ModuleCertificate] FetchModuleUsedTemplatesFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}
